export default (client) => {
  return {
    salesSubmit(
      {
        name,
        email,
        country,
        team,
        companySize,
        companyName,
        role,
        phoneNumber,
        message,
      },
      trackingData = null
    ) {
      const config = {}

      if (trackingData) {
        config.params = { track: JSON.stringify(trackingData) }
      }

      return client.post(
        '/saas/contact/sales-submit/',
        {
          name,
          email,
          country,
          team,
          company_size: companySize,
          company_name: companyName,
          role,
          phone_number: phoneNumber,
          message,
        },
        config
      )
    },
    partnerSubmit(
      {
        name,
        email,
        country,
        type,
        companySize,
        companyName,
        role,
        phoneNumber,
        message,
      },
      trackingData = null
    ) {
      const config = {}

      if (trackingData) {
        config.params = { track: JSON.stringify(trackingData) }
      }

      return client.post(
        '/saas/contact/partner-submit/',
        {
          name,
          email,
          country,
          type,
          company_size: companySize,
          company_name: companyName,
          role,
          phone_number: phoneNumber,
          message,
        },
        config
      )
    },
  }
}
